import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Organization, formatErrorMessage } from '../types';
import { useStrictModeGuard } from '../hooks/useStrictModeGuard';

const MyOrganization: React.FC = () => {
  const { executeOnce } = useStrictModeGuard();
  const [organization, setOrganization] = useState<Organization | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMyOrganization = useCallback(async (): Promise<void> => {
    try {
      setLoading(true);
      const response = await axios.get<Organization>('/organizations/my-organization');
      setOrganization(response.data);
    } catch (err) {
      setError(formatErrorMessage(err, 'An error occurred'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    executeOnce(() => {
      fetchMyOrganization();
    });
  }, [fetchMyOrganization, executeOnce]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <div>Loading organization...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        backgroundColor: '#fee2e2', 
        color: '#dc2626', 
        padding: '12px', 
        borderRadius: '6px', 
        marginBottom: '16px' 
      }}>
        {error}
      </div>
    );
  }

  return (
    <div>
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ margin: 0, color: '#1f2937' }}>My Organization</h1>
      </div>

      {organization && (
        <div className="card">
          <h3 style={{ margin: '0 0 16px 0', color: '#1f2937' }}>Organization Details</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
            <div>
              <strong>Name:</strong> {organization.name}
            </div>
            <div>
              <strong>Status:</strong> {organization.is_active ? 'Active' : 'Inactive'}
            </div>
            <div>
              <strong>Created:</strong> {new Date(organization.created_at).toLocaleDateString()}
            </div>
            {organization.description && (
              <div style={{ gridColumn: '1 / -1' }}>
                <strong>Description:</strong> {organization.description}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MyOrganization;
